import React, { useRef } from "react";
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import { FormatThaiCard } from "../../core/Helper";
import { useDispatch } from "react-redux";
import { setReminder } from "../../features/UserActions";
import styled from "styled-components";
import { FcDecision, FcReadingEbook } from "react-icons/fc";

import ConfirmDialogB from "../components/ConfirmDialogB";
import { useReactToPrint } from "react-to-print";
import { PDFViewer, StyleSheet } from "@react-pdf/renderer";
import DocumentBuilder from "../radi/DocumentBuilder";

function StudyShowResult(props) {
  const { userDetail, showStudyResult, setShowStudyResult, selectedRow } =
    props;
  const dispatch = useDispatch();
  const [dataX, setDataX] = useState(null);
  const [updateFlag, setUpdateFlag] = props.updateFlag;
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });
  const [repcheck, setRepCheck] = useState(1);
  const [fullScreen, setFullScreen] = useState(false);
  const [printFrm, setPrintFrm] = useState({ show: false, action: () => {} });

  const refForm1 = useRef(null);
  //const uploadType = {FILE:1, CAPTURED:2};
  const editorContentRef = useRef(null); //Reference of RichTextEditor's editor
  const editRef = useRef(null); // Referrence of RichTextEditor

  const [docu, setDocu] = useState();
  const [loading, setLoading] = props.loading;

  //----------------------------------------------------------------------
  useEffect(() => {
    if (showStudyResult.action != null) {
      getInfo(() => {
        showStudyResult.action();
      });
    }
    return () => {
      setDataX(null);
    };
  }, [showStudyResult?.show]);

  // Effect ข้อมูลผลอ่านและแสดงบนชุดรายงาน
  useEffect(() => {
    if (dataX && dataX.studyResult.length > 0) {
      setDocu(<DocumentBuilder data={dataX} setLoading={setLoading} />);
    }
  }, [dataX]);

  /*  แสดงข้อมูลคนไข้  */
  const getInfo = (callback) => {
    if (props.selectedRow == null) return;
    axios
      .post(
        process.env.REACT_APP_API + "api/studyinfo/getStudyInfoWithHistory",
        {
          StudyInfo: { ...props.selectedRow },
          UserInfo: userDetail,
        },
        HttpJsonHeader,
      )
      .then((response) => {
        // console.log("ALL RESULT", response.data);
        if (response.data) {
          let tmp = response.data;
          setDataX({
            studyInfo: {
              ...tmp.StudyInfo[0],
              patients_idcard:
                tmp &&
                tmp.StudyInfo[0]?.patients_idcard &&
                FormatThaiCard(response.data.StudyInfo[0]?.patients_idcard),
            },
            attachedFile: tmp.StudyFileAttached,
            priceItems: tmp.PriceItems,
            studyResult: tmp.StudyResults,
            studyHistory: tmp.StudyHistory,
          });
          // ประเภทของการบันทึกผล
          setRepCheck(
            tmp.StudyResults && tmp.StudyResults.length > 0
              ? tmp.StudyResults[0].result_type_id
              : 1,
          );
          callback();
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" }),
        ),
      );
  };

  // Print document
  const printResult = useReactToPrint({
    content: () => editorContentRef.current,
  });

  /*** -------------------------------------------------- */

  return (
    <MyModal
      show={showStudyResult.show}
      // size="xl"
      onHide={() => setShowStudyResult({ show: false })}
      backdrop={false}
      centered
      fullscreen={true}
    >
      <ModalHeaderBlack closeButton style={{ maxHeight: "50px" }}>
        <FcReadingEbook
          style={{ color: "yellow", fontSize: "30px", margin: "0 5px 0 5px" }}
        />
        ผลวินิจฉัย{props.formName}
        <div
          style={{
            flex: "1",
            display: "flex",
            padding: "0px 5px 0px 0px",
            justifyContent: "right",
          }}
        ></div>
      </ModalHeaderBlack>

      <ModalBodyBlack
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "0px",
        }}
      >
        <div style={{ display: "flex" }}>
          <ALabelTitle
            style={{ maxWidth: "90px", backgroundColor: "transparent" }}
          >
            ชือ-สกุล
          </ALabelTitle>
          <ALabelInfo style={{ flex: "1" }}>
            {dataX && dataX.studyInfo.patients_name}
          </ALabelInfo>
          <ALabelTitle style={{ maxWidth: "50px" }}>เพศ</ALabelTitle>
          <ALabelInfo style={{ flex: "1", maxWidth: "60px" }}>
            {dataX && dataX.studyInfo.patients_sex == "M" ? "ชาย" : "หญิง"}
          </ALabelInfo>
          <ALabelTitle style={{ maxWidth: "50px" }}>อายุ</ALabelTitle>
          <ALabelInfo style={{ flex: "1", maxWidth: "80px" }}>
            {dataX &&
              dataX.studyInfo.patients_age
                .replace(/^0+/g, "")
                .replace(/[y,Y]/g, " ปี")
                .replace(/[m,M]/, " เดือน")}
          </ALabelInfo>
          <ALabelTitle style={{ maxWidth: "50px" }}>HN</ALabelTitle>
          <ALabelInfo style={{ flex: "1", maxWidth: "120px" }}>
            {dataX && dataX.studyInfo.patientid}
          </ALabelInfo>
        </div>

        {/* แสดงผลอ่าน */}

        <ATabs defaultActiveKey="pdf" className="mb-3">
          <ATab eventKey="pdf" title="PDF">
            <div style={{ flex: "1" }}>
              <PDFViewer style={styles.container} children={docu}></PDFViewer>
            </div>
          </ATab>
          <ATab eventKey="text" title="Text">
            <Form.Control
              style={{ fontFamily: "Times New Roman", minHeight: "700px" }}
              as="textarea"
              defaultValue={
                dataX &&
                dataX?.studyInfo?.patients_name +
                  "\r\n" +
                  dataX?.studyInfo?.patients_name_eng?.replace(/\^+/g, "  ") +
                  "\r\n" +
                  "HN: " +
                  dataX?.studyInfo?.patientid +
                  "    อายุ: " +
                  (dataX?.studyInfo.patients_age
                    ? dataX?.studyInfo?.patients_age
                        .replace(/^0+/g, "")
                        .replace(/[y,Y]/g, " ปี")
                        .replace(/[m,M]/, " เดือน")
                    : "") +
                  "   เพศ: " +
                  dataX?.studyInfo?.patients_sex
                    ?.replace(/[f,F]/, "หญิง")
                    ?.replace(/[m,M]/, "ชาย") +
                  "\r\n" +
                  "\r\n" +
                  dataX?.studyResult[0]?.result_text
              }
              rows={20}
            />
          </ATab>
        </ATabs>
      </ModalBodyBlack>

      <ModalFooterBlack style={{ flex: "0.1" }}>
        <Form id="fromCheck" ref={refForm1} style={formStyle1}>
          <div style={{ flex: "1", display: "flex", padding: "2px" }}>
            <div
              style={{ display: "flex", flex: "3", padding: "2px 0 0 0px" }}
            ></div>

            <div>
              {}
              <Button style={{ margin: "2px" }} variant="info">
                <FcDecision style={{ height: "30px", width: "30px" }} />
                แจ้งปัญหา
              </Button>
              <Button
                style={{ margin: "5px", padding: "10px 20px 10px 20px" }}
                variant="danger"
                onClick={() => setShowStudyResult({ show: false })}
              >
                ปิด
              </Button>
            </div>
          </div>
        </Form>
      </ModalFooterBlack>
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
      {/* <PrintDocu {... {winState:[printFrm, setPrintFrm], ...editRef}} /> */}
    </MyModal>
  );
}

const Styles = {
  accordionBody: { background: "#222222", padding: "0 0 0 0px" },
  buttonTemplate: { marginRight: "5px" },
  buttonImage: {
    marginRight: "5px",
    color: "yellow",
    height: "30px",
    width: "30px",
  },
  buttonImageBig: {
    marginRight: "5px",
    color: "yellow",
    height: "40px",
    width: "40px",
  },

  innerIconButton: { marginTop: "-5px" },
};

const styles = StyleSheet.create({
  container: {
    border: "1px solid transparent",
    flex: 1,
    display: "flex",
    width: "100%",
    minHeight: "100vh",
    marginHorizontal: 0,
    marginVertical: 0,
    padding: 0,
  },
});

export default React.memo(StudyShowResult);

const formStyle1 = {
  flex: "1",
  display: "flex",
  padding: "0 0 0 0px",
  margin: "0 0 0 0px",
  borderRadius: "0px",
  flexDirection: "column",
};

const ATabs = styled(Tabs)`
  background-color: #121212;
  /* flex: 1; */
  justify-content: start;
`;

const ATab = styled(Tab)`
  /* background-color: red; */
  padding: 0;
  display: flex;
  flex: 1;
  height: 500px;
  justify-content: start;
`;

const ALabelTitle = styled.div`
  color: #ffffff;
  padding: 10px 10px;
`;

const ALabelInfo = styled.div`
  color: #2bf810;
  padding: 10px 10px;
  /* background-color: #c9bfbf; */
`;
